/**
 * Application-specific error codes
 * Must match server-side error codes
 */
export const ErrorCodes = {
  // 401xx - Authentication/User errors
  USER_DEACTIVATED: 40101,
  ACCOUNT_INACTIVE: 40102,
} as const;

export type ErrorCodeValue = (typeof ErrorCodes)[keyof typeof ErrorCodes];
